import type {
  EnableableButtonOverride,
  EnableableInputOverride,
} from "@redotech/redo-content-builder-common/brand-kit-zod";

export interface OrderLookupSettings {
  allowTrackingCodeOnlyAccess: boolean;
  backgroundColor: string;
  backgroundImageUrl?: string | null | undefined;
  /**
   * Optional minimum page height in px. When set, the lookup page renders at
   * least this tall (applied as `min-height`) so a background image/design can
   * extend beyond the lookup card. Unset → height is driven by content as
   * before. Capped at {@link ABSOLUTE_MAX_PAGE_HEIGHT}.
   */
  minPageHeightPx?: number | null | undefined;
  cardBackgroundColor: string;
  cardBorderRadius: number;
  cardBorderWidth: number;
  cardBorderColor: string;
  cardShadowEnabled: boolean;
  titleText: string;
  titleColor: string;
  titleFontFamily?: string | null | undefined;
  bodyFontFamily?: string | null | undefined;
  buttonText: string;
  buttonOverride?: EnableableButtonOverride | null | undefined;
  inputOverride?: EnableableInputOverride | null | undefined;
  emailLabel?: string | null | undefined;
  emailPlaceholder?: string | null | undefined;
  orderLabel?: string | null | undefined;
  orderPlaceholder?: string | null | undefined;
  /**
   * Merchant-authored CSS, applied inside the storefront's shadow root against
   * the form's `data-target` hooks. Theme CSS cannot reach past that boundary.
   */
  customCss?: string | null | undefined;
}

export const DEFAULT_ORDER_LOOKUP_SETTINGS: OrderLookupSettings = {
  allowTrackingCodeOnlyAccess: false,
  backgroundColor: "#FFFFFF",
  cardBackgroundColor: "#FFFFFF",
  cardBorderRadius: 0,
  cardBorderWidth: 0,
  cardBorderColor: "#D6D6D6",
  cardShadowEnabled: true,
  titleText: "Track your order",
  titleColor: "#0F172A",
  buttonText: "Track order",
  emailLabel: "Email or zip code",
  emailPlaceholder: "Enter email or zip...",
  orderLabel: "Order # or tracking #",
  orderPlaceholder: "Enter order or tracking #...",
};

export function defaultOrderLookupSettings(): OrderLookupSettings {
  return { ...DEFAULT_ORDER_LOOKUP_SETTINGS };
}
